"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TeamsIntegrationReviewStep = require("./TeamsIntegrationReviewStep");
Object.keys(_TeamsIntegrationReviewStep).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TeamsIntegrationReviewStep[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TeamsIntegrationReviewStep[key];
    }
  });
});